import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Tabs } from 'antd';
import i18next from 'i18next';
import moment from 'moment';
import { getNicheById, getOrderHistory } from 'redux/orders/actions';
import CommentsList from 'containers/Comments/List';
import AddOrderComment from '../components/AddOrderComment';
import Edit from '../../rest/Edit';
import Form from '../components/Form';
import OrderInfo from '../components/OrderInfo';
import OrdersEditStyles from './styles';
import OrderStatus from '../components/OrderStatus';

const UsersEdit = (props) => {
  const dispatch = useDispatch();
  const [isShowForm, setIsShowForm] = useState(false);
  const currentOrder = useSelector((state) => state.orders.currentData);
  const commentTotal = useSelector((state) => state.comments.total);

  const breadCrumb = [
    {
      title: i18next.t('orders.header'),
      path: '/orders',
    },
    {
      title: `Order #${currentOrder?.codeCustomer}`,
      path: `/orders/${currentOrder?.id}/edit`,
    },
  ];
  const handleToggleForm = () => {
    setIsShowForm(!isShowForm);
  };

  useEffect(() => {
    currentOrder?.niche && dispatch(getNicheById(currentOrder?.niche));
    // eslint-disable-next-line
  }, [currentOrder?.niche]);
  useEffect(() => {
    currentOrder?.backupId && dispatch(getOrderHistory(currentOrder?.backupId));
    // eslint-disable-next-line
  }, [currentOrder?.backupId]);
  return (
    <OrdersEditStyles>
      <Edit
        {...props}
        resource="orders"
        formatOnSubmit={(data) => ({
          ...data,
          ...(data.deadline && {
            deadline: moment(data.deadline).toISOString(),
          }),
          ...(data.finishedDate && {
            finishedDate: moment(data.finishedDate).toISOString(),
          }),
        })}
        defaultOptions={{
          extraParams: { includes: 'products' },
        }}
        breadCrumb={breadCrumb}
        customSubmitButton={!isShowForm ? null : undefined}
        customOnBack={handleToggleForm}
      >
        <Tabs type="card">
          <Tabs.TabPane
            tab="Information"
            key="Information"
            tabKey="Information"
          >
            {!isShowForm ? (
              <div>
                <OrderInfo
                  isShowForm={isShowForm}
                  setIsShowForm={setIsShowForm}
                  order={currentOrder}
                  handleToggleForm={handleToggleForm}
                />
              </div>
            ) : (
              <div className="order-info-section">
                <Form isEdit />
              </div>
            )}
          </Tabs.TabPane>
          <Tabs.TabPane key="process" tab="Order process" tabKey="process">
            <OrderStatus order={currentOrder} />
          </Tabs.TabPane>
          <Tabs.TabPane
            forceRender
            key="comment"
            tab={`Comments (${commentTotal})`}
            tabKey="comment"
          >
            <AddOrderComment />
            {currentOrder?.id && (
              <CommentsList
                initialFilter={{
                  filter: {
                    orderId: currentOrder?.backupId,
                  },
                }}
                isList
              />
            )}
          </Tabs.TabPane>
        </Tabs>
      </Edit>
    </OrdersEditStyles>
  );
};

UsersEdit.propTypes = {};

export default UsersEdit;
